<style scoped lang="scss">

</style>

<template>
    <div class="uk-width-1-1 uk-grid">
        <header-row/>
        <div class="uk-width-1-1 uk-margin-bottom">
            <h2>Attached Documents:</h2>

            <table class="uk-table uk-table-striped">
                <thead>
                <tr>
                    <th>Household Member</th>
                    <th>Document Type</th>
                    <th>File Name</th>
                </tr>
                </thead>
                <tbody v-for="request in requests">
                <tr v-for="doc in request.documents" v-if="documentIds.includes(doc.id)">
                    <td>{{ request.household_member.first_name }} {{ request.household_member.last_name }}</td>
                    <td>{{ request.category.document_category_name }}</td>
                    <td>{{ doc.filename }}</td>
                </tr>
                </tbody>
                <tbody>
                <tr v-if="landlordW9 && documentIds.includes(landlordW9.id)">
                    <td>Landlord</td>
                    <td>Landlord W9</td>
                    <td>{{ landlordW9.filename }}</td>
                </tr>
                <tr v-if="landlordDocumentation && documentIds.includes(landlordDocumentation.id)">
                    <td>Landlord</td>
                    <td>Landlord Documentation</td>
                    <td>{{ landlordDocumentation.filename }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import HeaderRow from "./HeaderRow";

    export default {
        name: "AttachedDocuments",
        props: {
            documentIds: {
                type: Array,
                default: () => [],
            }
        },
        components: {HeaderRow},

        computed: {
            landlordConfirmation() {
                for(let i in this.landlordConfirmations) {
                    if(this.landlordConfirmations[i].edited_amount != null) {
                        return this.landlordConfirmations[i];
                    }
                }
                return {};
            },
            landlordW9() {
                if(this.landlordConfirmation) {
                    for(var i in this.landlordConfirmation.documents) {
                        let d = this.landlordConfirmation.documents[i];
                        for(var j in d.categories) {
                            if(d.categories[j].key === 'landlord-w9') {
                                return d;
                            }
                        }
                    }
                }
                return false;
            },
            landlordDocumentation() {
                if(this.landlordConfirmation) {
                    for(var i in this.landlordConfirmation.documents) {
                        let d = this.landlordConfirmation.documents[i];
                        for(var j in d.categories) {
                            if(d.categories[j].key === 'landlord-documentation') {
                                return d;
                            }
                        }
                    }
                }
                return false;
            },
            ...mapState('Application', {
                assets: 'assets',
                application: 'application',
                applicant: 'applicant',
                hhMembers: 'hhMembers',
                requests: 'documentRequests',
                documents: 'documents',
                renterManager: 'renterManager',
                landlordConfirmations: 'landlordConfirmations',
            }),
            ...mapGetters('Application', {
                headOfHousehold: 'headOfHousehold'
            }),

        },

        methods: {
            documentsForRequest(request) {

            }
        }
    }
</script>
